
import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as dialog      from "../dialog";
import * as main        from "../main";
import * as navigation  from "../navigation";
import * as viewmode    from "../viewmode";
import * as grid        from "../grid";

function removeMessage(preComMsgId: number): void {

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("PreComMsgConfig/DeleteMessage") + "?preComMsgId=" + preComMsgId,
        success: function (responseData: responseModel| undefined | null) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            $("#DivTextArea").html('');                                         // message area
            $("#PreComMsgConfigGrid").data("kendoGrid").dataSource.read();      // refresh the grid
        }
    });
}


export function initialize(readonly: boolean, formid: string): void {

    // Create new record ...
    $(document)        
        .off("click.overviewAdd", "#PreComMsgConfigGrid .k-grid-add")
        .on("click.overviewAdd", "#PreComMsgConfigGrid .k-grid-add", function (e: JQuery.Event): void {

        // Prevent default behaviour
        e.preventDefault();

        // Load create form into the current module div
        navigation.navigateToSpecificUrl("PreComMsgConfig/AddMessage");
    });

    if (readonly) {
        viewmode.disableAllInputs(formid);
    }
    grid.loadGridOptions("PreComMsgConfigGrid");
}

export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgGridVM;

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("PreComMsgConfig/ShowMessage?preComMsgId=" + dataItem.PreComMsgID + "&breadcrumbLabel=" + dataItem.Label);
}

export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgGridVM;

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("PreComMsgConfig/EditMessage?preComMsgId=" + dataItem.PreComMsgID + "&breadcrumbLabel=" + dataItem.Label);
}

export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid) {
        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as PreComMsgGridVM;

        // Post Data
        removeMessage(dataItem.PreComMsgID);
    }

    function callingCallback(): void {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}
